import { Routes } from '@angular/router';
import { ExternalComponent } from './external.component';
import { guestOnlyCanMatch } from '../../../guards/auth-guest.guard';

export const externalRoutes: Routes = [
  {
    path: 'auth',
    component: ExternalComponent,
    children: [
      { path: '', redirectTo: 'sign-in', pathMatch: 'full' },
      {
        path: 'sign-in',
        loadComponent: () =>
          import('../../pages/auth/auth.component').then(
            (x) => x.AuthComponent
          ),
        canMatch: [guestOnlyCanMatch],
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import('../../pages/auth/auth.component').then(
            (x) => x.AuthComponent
          ),
        canMatch: [guestOnlyCanMatch],
      },
      {
        path: 'reset-password/fail',
        loadComponent: () =>
          import('../../pages/auth/auth.component').then(
            (x) => x.AuthComponent
          ),
        canMatch: [guestOnlyCanMatch],
      },
    ],
  },
];
